<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="deleteFunctional">
    <div slot="header" class="modal-header">删除功能区</div>   
    <p>{{'是否确认删除功能区【'+ name +'】'}}</p>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { deleteFunctionalarea } from "api/functionalArea";
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    name:{
      type:String,
      default:'abc'
    },
    fid:{
      type:String,
      default:'ccc'
    },
  },
  data () {
    return {
       show:false
    };
  },
  watch:{
   n(val){
     this.show = true;
   }
 },
  methods:{
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    deleteFunctional(){
      let fid = this.fid
      if(!fid){
        this.changeLoading()
        return
      }
      deleteFunctionalarea({ functionalAreaFid:fid }).then(res => {       
        this.changeLoading();
        this.$Message.success('删除成功');
        this.show = false;
        this.$emit('refresh')
      }).catch(error => {
        this.changeLoading(); 
      })   
   }
  }
}
</script>
